
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import ScrollToTop from "@/components/ScrollToTop";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="max-w-4xl mx-auto px-4 py-20 mt-16">
        <h1 className="text-4xl font-bold text-primary mb-8">Mentions légales</h1>
        <p className="text-sm text-foreground/60 mb-8">Dernière mise à jour : mai 2025</p>
        
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">1. Éditeur du site</h2>
            <p>
              Ce site est édité par : Meredith Meneora<br />
              13 Allée de la Collégiale, 91150 Étampes<br />
              Téléphone : 06 07 50 74 12 (WhatsApp uniquement)<br />
              Site : <a href="https://meneora.fr" className="text-primary hover:underline">https://meneora.fr</a>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">2. Hébergeur du site</h2>
            <p>
              Lovable – Créateur de sites web<br />
              <a href="https://lovable.dev" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://lovable.dev</a>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">3. Propriété intellectuelle</h2>
            <p>Les contenus de ce site (textes, images, supports) sont la propriété exclusive de Meredith Meneora. Toute reproduction ou diffusion sans autorisation est interdite.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">4. Données personnelles</h2>
            <p>Les données collectées sont confidentielles, utilisées uniquement dans le cadre de la relation client, et ne sont jamais revendues. Pour toute demande, vous pouvez me contacter via WhatsApp.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">5. Responsabilité</h2>
            <p>Les accompagnements proposés ne remplacent aucun suivi médical ou psychologique. Ils s'inscrivent dans une démarche complémentaire de bien-être personnel et professionnel.</p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/">
            <Button variant="outline">← Retour à l'accueil</Button>
          </Link>
        </div>
      </section>
      
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default MentionsLegales;
